<div class="mobile-menu">
  <div class="top-bar">
    <div class="mobile-menu_logo d-flex">
      <img
        src="/assets/images/logo-new.svg"
        alt="Logo"
        class="logo-img img-fluid mr-2"
      />
    </div>
    <div class="mobile-menu_trigger d-flex">
      <img
        src="/assets/images/menu/mobile-trigger.svg"
        alt="Open menu"
        class="open-menu img-fluid mt-2"
        *ngIf="!menuOpen"
        (click)="showMenu()"
      />
      <img
        src="/assets/images/menu/close-menu.svg"
        alt="Close menu"
        class="open-menu img-fluid mt-2"
        *ngIf="menuOpen"
        (click)="showMenu()"
      />
    </div>
  </div>
</div>

<div class="menu-inner" [class.show]="menuOpen">
  <div class="menu-inner__scroll">
    <ul ngbNav class="main-menu" orientation="vertical">
      <li [ngbNavItem]="entry.route" *ngFor="let entry of entries">
        <a
          ngbNavLink
          [routerLink]="entry.route"
          [class.active]="router.url.startsWith(entry.route)"
          (click)="closeMenu()"
        >
          <img
            [src]="getMenuIcon(entry.route, entry.icon)"
            [alt]="entry.label | translate"
            class="img-fluid menu-icon"
          />
          {{ entry.label | translate }}
        </a>
      </li>
    </ul>

    <ul
      ngbNav
      class="bottom-menu"
      orientation="vertical"
      *ngIf="isGym && hasGymPermission"
    >
      <li [ngbNavItem]="'/settings'">
        <a
          ngbNavLink
          [routerLink]="'/settings'"
          [class.active]="router.url.includes('/settings')"
          (click)="closeMenu()"
        >
          <img
            [src]="getMenuIcon('/settings', 'settings')"
            [alt]="TranslationEnum.Menu.SETTINGS | translate"
            class="img-fluid menu-icon"
          />
          {{ TranslationEnum.Menu.SETTINGS | translate }}
        </a>
      </li>
    </ul>
  </div>

  <div class="profile-section">
    <div
      class="profile"
      (click)="expandProfile()"
      [class.arrow-up]="profileExpand"
    >
      <div class="avatar">
        <img
          src="/assets/images/menu/profile-icon-new.svg"
          alt="Profile Icon"
          class="img-fluid profile"
        />
        <span class="ml-2 profile-name">{{ username$ | async }}</span>
      </div>
      <img
        src="/assets/images/menu/arrow-down.svg"
        alt="Expand profile menu"
        class="img-fluid arrow-down"
      />
    </div>
    <div class="profile-menu" *ngIf="profileExpand">
      <ul class="more">
        <li>
          <a href="" (click)="logout()">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</div>
